<template>
          <div class="row list_view related_program">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

              <template v-if="relatedPrograms && relatedPrograms.length > 0">
                <div class="row result_row" v-for="(program, index) in relatedPrograms">

                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 thumbnail_section" @click.stop="goToProgramGuideIntroduction(program)">
                      <div class="thumbnail_container ace_sec">
                        <div class="thumbnail_img" v-if="program.thumbnailURL">
                          <img v-bind:src="program.thumbnailURL" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/program-default.svg';">
                        </div>
                        <div class="thumbnail" v-else>
                          <div class="txt_bx" v-html="setTitleInitials(program.title)"></div>
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-6 col-lg-6 col-md-5 col-sm-8 entity_detail_section">
                      <div class="row">
                        <div class="col-12 title_row">
                          <a href="javascript://" class="title ace_sec_txt" :id="'entityName_' + index" @click.stop="goToProgramGuideIntroduction(program)" :aria-label="program.title">{{program.title}}</a>

                          <b-popover :target="'entityName_' + index" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer_' + index">
                            <div class="title_container">
                              {{program.title}}
                            </div>
                          </b-popover>
                          <div :id="'entityNameContainer_' + index" class="title_container_popup"></div>

                        </div>

                        <div class="col-12 description ace_sec_txt" :id="'entityDesc_' + index" v-if="program.description">
                           <span class="desc_txt" v-html="program.description"></span>
                        </div>
                        <template v-if="program.description">
                          <div class="col-12 lnk_container" :class="showMoreDescLnk(index)">
                            <b-link v-b-modal="'entityDescModal_' + index">more</b-link>
                          </div>
                          <b-modal size="xl" :id="'entityDescModal_' + index" :title="program.title" ok-only ok-title="close">

                            <div class="row">

                              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 thumbnail_section">
                                  <div class="thumbnail_container ace_sec">
                                    <div class="thumbnail_img" v-if="program.thumbnailURL">
                                      <img v-bind:src="program.thumbnailURL" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/program-default.svg';">
                                    </div>
                                    <div class="thumbnail" v-else>
                                      <div class="txt_bx" v-html="setTitleInitials(program.title)"></div>
                                    </div>
                                  </div>
                              </div>

                              <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 description">
                                <div v-html="program.description"></div>
                              </div>

                            </div>

                          </b-modal>
                        </template>
                      </div>
                    </div>


                    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-12 other_info">
                      <div class="row" v-if="showCreditInfo(program.code)">
                        <div class="col-12 progress-row progress_bar_sec">
                          <div class="progress-bar-label">
                            {{getCreditInfo(program.code).transferred}} out of {{getCreditInfo(program.code).total}} credits
                          </div>
                          <b-progress :max="getCreditInfo(program.code).total">
                            <b-progress-bar :value="getCreditInfo(program.code).transferred"></b-progress-bar>
                          </b-progress>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
                          <div class="info_title">median income</div>
                          <div class="info_val ace_sec_txt" v-if="program.medianIncomePerYear" :aria-label="'median income is ' + program.medianIncomePerYear">
                            $<span v-html="addCommaInNumber(program.medianIncomePerYear)"></span>
                          </div>
                          <div v-else class="info_no_val ace_sec_txt" aria-label="median income is not available for this program">N/A</div>
                        </div>

                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
                          <div class="info_title">job postings</div>
                          <div v-if="program.totalJobPostings" class="info_val ace_sec_txt" :aria-label="'job postings are ' + program.totalJobPostings + ' for this program'">
                            <span v-html="addCommaInNumber(program.totalJobPostings)"></span>
                          </div>
                          <div v-else class="info_no_val ace_sec_txt" aria-label="job postings are not available for this program">N/A</div>
                        </div>

                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
                          <div class="info_title">growth</div>
                          <div v-if="program.growthRate" class="info_val ace_sec_txt" :aria-label="'growth is ' + program.growthRate + ' for this program'">
                          <span v-html="(Math.round(program.growthRate * 100) / 100).toFixed(1)"></span>%
                          </div>
                          <div v-else class="info_no_val ace_sec_txt" aria-label="growth not available for this program">N/A</div>
                        </div>
                      </div>
                    </div>

                  </div>
                </template>
              </div>
          </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import _ from 'lodash'
  import CourseProgressBar from './CourseProgressBar'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'related-program',
    props: ['pathwayId', 'cipCode', 'programGuideCode', 'type', 'sourceProgram'],
    components: {
      CourseProgressBar
    },
    data () {
      return {
        selfReportedCourseMap: {},
        relatedPrograms: [],
        userId: localStore.getItem('userid'),
        username: localStore.getItem('userFullName'),
        isCoursesLoaded: false,
        clickedCourse: '',
        selectedStatus: '',
        courseStatusMap: {
          0: 'Not Started',
          1: 'In Progress',
          2: 'Completed',
          7: 'Couldn\'t Complete'
        },
        courseStatusBackgroundMap: {
          0: 'status-not-started',
          1: 'status-in-progress',
          2: 'status-completed',
          7: 'status-not-completed'
        }
      }
    },
    mounted () {
      this.showLoader()
      this.loadRelatedProgramList()
    },
    methods: {
      ...mapActions([
        'loadRelatedPrograms'
      ]),
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      setThumbnailTitle (course) {
        return course.programCode
      },
      showCreditInfo (rpCode){
          let creditInfo = {}
          for(let i=0;i<this.sourceProgram.relatedProgramsCreditInfo.length;i++){
            creditInfo = this.sourceProgram.relatedProgramsCreditInfo[i]
            if(rpCode === creditInfo.programCode){
              return true
              break
            }
          }
          return  false
      },
      getCreditInfo (rpCode) {
          if(this.sourceProgram.relatedProgramsCreditInfo.length>0){
            for(let i=0;i<this.sourceProgram.relatedProgramsCreditInfo.length;i++){
              let creditInfo = this.sourceProgram.relatedProgramsCreditInfo[i]
              if(rpCode === creditInfo.programCode){
                return creditInfo
                break
              }
            }
          }
      },
      async updateCourseStatus (streamId, status) {
    		let data = {
          uuid: streamId,
          status: status
        }
        this.updateProgramCourseStatus(data).then(result => {
        	this.resetPage()
        })
      },
      async loadRelatedProgramList () {
        this.loadRelatedPrograms(this.pathwayId).then(result => {
          this.relatedPrograms = result;
          this.totalElements = result.length
          this.hideLoader()
          this.selected = [],
          this.isCoursesLoaded = true
        })
      },
      addCommaInNumber (numValue) {
        return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      resetPage () {
        this.loadRelatedProgramList()
      },
      setTitleInitials (entityTitle) {
        let getTitleInitials = entityTitle.match(/\b(\w)/g)
        return getTitleInitials.join('')
      },
      showMoreDescLnk (entityDescRowId) {
        let descContainerHeight = $('#entityDesc_' + entityDescRowId + ' .desc_txt').height()
        if (descContainerHeight > 65) {
          return 'show_more_link'
        } else {
          return 'hide_more_link'
        }
      },
      goToProgramGuideIntroduction (programGuide) {
        let routerParams = {
          cipCode: programGuide.cipCode,
          programGuideCode: programGuide.code,
          type: programGuide.type,
          returnTo: 'relatedPrograms',
          showBackToResultButton: false
        }
        let returnRouterParams = {
          cipCode: this.cipCode,
          programGuideCode: this.programGuideCode,
          type: this.type,
          returnTo: 'exploreProgramGuideResults',
          showBackToResultButton: true
        }
        localStore.setItem('returnRouterParams', JSON.stringify(returnRouterParams))
        return this.$router.push({ name: 'programGuideIntroduction', params: routerParams, query: {returnTo: 'relatedPrograms'} })
      }
    },
    computed: {

    }
  }
</script>

<style>
  .title-txt {
    color: #fff;
    margin-top: 3px;
    font-weight: 500;
    text-align: center;
  }

  div[id^="courseStatusPopup-"] .popover {
    transform: translate3d(-8px, 20px, 0px) !important;
    max-width: 220px !important;
    width: 220px !important;
    height: 225px !important;
    margin-top: 15px;
  }

  div[id^="courseStatusPopup-"] .popover .arrow {
    display: none !important;
  }

  .form-check-input {
    top: 12px;
    cursor: pointer;
  }

  .status-not-started {
    background: #b4b4b4 !important;
  }

  .status-in-progress {
    background: #dd9623 !important;
  }

  .status-completed {
    background: #0a7714 !important;
  }

  .status-not-completed {
    background: #f40909 !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/transfer/components/RelatedProgram.vue